import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { WebSocketSessionzi1ianvyj32u as WebSocketSession } from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/WebSocketSession.mjs';
import { DefaultWebSocketSession3h8506yqzs5fx as DefaultWebSocketSession } from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/DefaultWebSocketSession.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultClientWebSocketSessionClass;
function DefaultClientWebSocketSession() {
  if (DefaultClientWebSocketSessionClass === VOID) {
    class $ {
      constructor(call, delegate) {
        this.$$delegate_0__1 = delegate;
        this.call_1 = call;
      }
      *send_sburzs_k$(frame, $completion) {
        yield* this.$$delegate_0__1.send_sburzs_k$(frame, $completion);
        return Unit_instance;
      }
      *flush_4wsz1p_k$($completion) {
        yield* this.$$delegate_0__1.flush_4wsz1p_k$($completion);
        return Unit_instance;
      }
      set_maxFrameSize_k27os3_k$(_set____db54di) {
        this.$$delegate_0__1.set_maxFrameSize_k27os3_k$(_set____db54di);
      }
      get_maxFrameSize_9zaht9_k$() {
        return this.$$delegate_0__1.get_maxFrameSize_9zaht9_k$();
      }
      get_incoming_u9os29_k$() {
        return this.$$delegate_0__1.get_incoming_u9os29_k$();
      }
      get_outgoing_us7o3v_k$() {
        return this.$$delegate_0__1.get_outgoing_us7o3v_k$();
      }
      get_coroutineContext_115oqo_k$() {
        return this.$$delegate_0__1.get_coroutineContext_115oqo_k$();
      }
      start_ye6294_k$(negotiatedExtensions) {
        this.$$delegate_0__1.start_ye6294_k$(negotiatedExtensions);
      }
      get_closeReason_g1m41f_k$() {
        return this.$$delegate_0__1.get_closeReason_g1m41f_k$();
      }
    }
    initMetadataForClass($, 'DefaultClientWebSocketSession', VOID, VOID, [WebSocketSession(), DefaultWebSocketSession()], [1, 0]);
    DefaultClientWebSocketSessionClass = $;
  }
  return DefaultClientWebSocketSessionClass;
}
var DelegatingClientWebSocketSessionClass;
function DelegatingClientWebSocketSession() {
  if (DelegatingClientWebSocketSessionClass === VOID) {
    class $ {
      constructor(call, session) {
        this.$$delegate_0__1 = session;
        this.call_1 = call;
      }
      *send_sburzs_k$(frame, $completion) {
        yield* this.$$delegate_0__1.send_sburzs_k$(frame, $completion);
        return Unit_instance;
      }
      *flush_4wsz1p_k$($completion) {
        yield* this.$$delegate_0__1.flush_4wsz1p_k$($completion);
        return Unit_instance;
      }
      set_maxFrameSize_k27os3_k$(_set____db54di) {
        this.$$delegate_0__1.set_maxFrameSize_k27os3_k$(_set____db54di);
      }
      get_maxFrameSize_9zaht9_k$() {
        return this.$$delegate_0__1.get_maxFrameSize_9zaht9_k$();
      }
      get_incoming_u9os29_k$() {
        return this.$$delegate_0__1.get_incoming_u9os29_k$();
      }
      get_outgoing_us7o3v_k$() {
        return this.$$delegate_0__1.get_outgoing_us7o3v_k$();
      }
      get_coroutineContext_115oqo_k$() {
        return this.$$delegate_0__1.get_coroutineContext_115oqo_k$();
      }
    }
    initMetadataForClass($, 'DelegatingClientWebSocketSession', VOID, VOID, [WebSocketSession()], [1, 0]);
    DelegatingClientWebSocketSessionClass = $;
  }
  return DelegatingClientWebSocketSessionClass;
}
//region block: exports
export {
  DefaultClientWebSocketSession as DefaultClientWebSocketSession1n8ok3lng45wy,
  DelegatingClientWebSocketSession as DelegatingClientWebSocketSessiono1sywc6weckz,
};
//endregion

//# sourceMappingURL=ClientSessions.mjs.map
